<div
  class="bg-card rounded-2xl p-2 w-full max-w-2xl items-center gap-3 flex justify-between border border-card-muted shadow-sm mt-3 dark:border-foreground-tertiary"
   (click)="onStartAssessment()" > 
  <img class="w-16 h-16" src="assets/images/file-new.png" alt="" />

  <div class="flex gap-2 items-center justify-center">
    <div class="flex flex-col gap-1">
      <h2 class="font-semibold text-xl">Start Your Health Assessment</h2>
      <p class="text-sm text-muted-color">
        Complete 1 quick pre-assessment to discover your health score, BMI, anf nutrition insight.
      </p>
    </div>

    <i class="pi pi-arrow-right text-primary mr-2.5 font-bold " (click)="onStartAssessment()"></i>
  </div>
</div>
